<script lang="ts">
  import { toHeaderCase } from 'js-convert-case';

  interface Props {
    value?: ObjectType<string>;
  }

  let { value = {} }: Props = $props();
</script>

<div class="comp-alert-list-type">Alert list type</div>

<style>
</style>
